'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAdjustedPath = undefined;

var _getApi = require('./getApi');

var _getApi2 = _interopRequireDefault(_getApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getAdjustedPath = exports.getAdjustedPath = function getAdjustedPath(path) {
  return path[0] !== '/' ? '/' + path : path;
}; //import {
//NODE_ENV,
//} from 'config';

var getApiPath = function getApiPath(path) {
  //if (NODE_ENV === 'development') {
  //return `http://127.0.0.1:3002/json${adjustedPath}`;
  //}
  // query the API server directly
  var adjustedPath = getAdjustedPath(path);
  //console.log('adjusted path', adjustedPath);
  return (0, _getApi2.default)() + '/json' + adjustedPath;
};

exports.default = getApiPath;


//////////////////
// WEBPACK FOOTER
// ./src/shared/redux/utils/Api/getApiPath.js
// module id = 1304
// module chunks = 0